import {
  FETCH_ALL_ACTIVITY_REQUEST,
  FETCH_ALL_ACTIVITY_SUCCESS,
  FETCH_ALL_ACTIVITY_FAILURE,
  CLEAR_ALL_ACTIVITY,
} from './allActivityLogTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const allActivityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_ACTIVITY_REQUEST:
      return { loading: true, data: null, error: null };
    case FETCH_ALL_ACTIVITY_SUCCESS:
      return { loading: false, data: action.payload, error: null };
    case FETCH_ALL_ACTIVITY_FAILURE:
      return { loading: false, data: null, error: action.payload };
    case CLEAR_ALL_ACTIVITY:
      return initialState;
    default:
      return state;
  }
};

export default allActivityLogReducer;
